/**
 * Default tenant website used whenever a custom URL is missing/invalid.
 * @type {string}
 */
export const DEFAULT_WEBSITE_URL = 'https://www.paxafe.com'

/**
 * Returns a safe website URL that can be rendered in UI links.
 * Only `http` and `https` protocols are allowed; all invalid inputs fallback to default.
 *
 * @param {unknown} websiteUrl Raw tenant website value from API/config.
 * @returns {string} Safe URL string guaranteed to be usable in href.
 */
export const getSafeWebsiteUrl = (websiteUrl) => {
  if (typeof websiteUrl !== 'string' || !websiteUrl.trim()) {
    return DEFAULT_WEBSITE_URL
  }

  try {
    // Validate protocol to avoid javascript:, data:, or other unsafe schemes.
    const parsedUrl = new URL(websiteUrl)
    if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
      return parsedUrl.toString()
    }
  } catch (error) {
    console.error(error)
    // Fallback to default when tenant URL is malformed.
  }

  return DEFAULT_WEBSITE_URL
}
